<template>

    <div class="w-full" style="position: relative;">   
        <DataTable
            lazy paginator :rows="this.pagination.rows"
            @page="onPage"
            :first="this.pagination.first"
            :loading="loading"
            :totalRecords="this.pagination.totalRecords"
            dataKey="id"
            :value="this.reservedItems"
            v-model:filters="filters"
            @filter="onFilter"
            filterDisplay="row" 
            v-model:selection="this.selectedItem"
            stripedRows
            row-hover
            
            selectionMode="single"
            :metaKeySelection="false"
            tableStyle="min-width: 10rem"

            
            v-model:expandedRows="expandedRows"
            >

            <Column expander style="width: 1rem" />
            
            <Column header="" style="width: 2rem">
                <template #body="slotProps">
                    <img :src="`${slotProps.data.product.image}`" :alt="slotProps.data.product.image" class="shadow-4 border-round" height="52" />
                </template>
            </Column>

            <!--
            scrollable
            :virtualScrollerOptions="{ itemSize: 50 }"
            :scrollHeight="`${400}px`"
            -->
            <Column header="" style="min-width: 1%"
                filterField="color"
                :showFilterMenu="false" :filterMenuStyle="{ width: '1%' }"
            >
              <template #body="slotProps">
                <div class="flex align-items-center">
                    <div
                    class="color-box mr-1"
                    :style="{ backgroundColor: slotProps.data.color.colorHash }"
                    ></div>
                    <div>{{ slotProps.data.color.code }}</div>
                </div>
              </template>
              <template #filter="{ filterModel, filterCallback }">
                <PrimevueSelect v-model="filterModel.value" @change="filterCallback()"
                        :options="this.colors" optionLabel="code" placeholder="Vyber farbu"
                        class="p-column-filter" style="min-width: 1%" >

                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <div
                              class="color-box mr-1"
                              :style="{ backgroundColor: slotProps.option.colorHash }"
                            ></div>  
                            <div>{{ slotProps.option.code }}</div>
                        </div>
                    </template>
                </PrimevueSelect>
              </template>
            </Column>
    
            <Column field="product.code" header="Kód"
                    filterField="product"
                    :showFilterMenu="false" :filterMenuStyle="{ width: '2%' }" style="width: 2%"
                    >
                    <template #body="slotProps">
                        {{ slotProps.data.product.code }}
                    </template>
                    
                    <template #filter="{ filterModel, filterCallback }">
                        <PrimevueSelect v-if="!this.search" 
                                v-model="filterModel.value" 
                                @change="filterCallback()" filter
                                :options="this.products" optionLabel="code" placeholder="Vyb. product"
                                class="p-column-filter" style="min-width: 2%" >
                            <template #option="slotProps">
                                {{slotProps.option.code}}
                            </template>
                        </PrimevueSelect>

                        <InputText v-if="this.search" 
                                    v-model="filterModel.value" type="text" 
                                    @keydown.enter="filterCallback()" 
                                    class="p-column-filter"
                                    placeholder="Hľadať" style="min-width: 5rem"/>

                    </template>
            </Column>
            

            <Column field="product.name" header="Názov">
            </Column>       
           
            <Column v-if="!this.search" field="product.category.name" header="Kategória"
                    filterField="category"
                    :showFilterMenu="false" :filterMenuStyle="{ width: '3%' }" 
                    style="min-width: 3%"
                    >
                    <template #body="slotProps">
                        {{ slotProps.data.product.category.name }}
                    </template>
                    
                    <template #filter="{ filterModel, filterCallback }">
                        <PrimevueSelect v-model="filterModel.value" @change="filterCallback()"
                                :options="this.categories" optionLabel="name" placeholder="Vyb. kateg."
                                class="p-column-filter" style="min-width: 3%" >
                            <template #option="slotProps">
                                {{slotProps.option.name}}
                            </template>
                        </PrimevueSelect>
                    </template>
            </Column>

            <Column field="numberOfItem" header="Počet kusov" ></Column>


              <template #expansion="slotProps">
                <div style="padding-left: 2rem;">
                    
                    <DataTable :value="slotProps.data.items" 
                      dataKey="id"
                      stripedRows
                      row-hover
 
                    >
                      <Column field="code" header="Kód"></Column>
                                   
                      <Column field="length" header="Dĺžka" ></Column>
                    
                      <Column field="location" header="Umiestnenie"></Column>
                      
                      <Column field="numberOfItem" header="Počet kusov" style="min-width: 1%"></Column>  

                      <Column v-if="this.search" style="width: 23%">
                        <template #body="subSlotProps">
                          <div class="" >
                            <PrimevueButton @click="initOrders(slotProps.data.id,subSlotProps.index)" 
                                
                                label="" 
                                style="height: 2rem;"
                                class="flex justify-content-between w-full " outlined
                                id="item-order">
    
                              <span v-if="subSlotProps.data.selectedOrder">{{subSlotProps.data.selectedOrder.orderCode}}</span>
                              <span v-if="!subSlotProps.data.selectedOrder">Vyb. objed.</span>
    
                              <span class="flex justify-content-center align-items-center" style="width: 1.5rem;">
                                <svg width="14" height="14" viewBox="0 0 14 14" 
                                      fill="none" xmlns="http://www.w3.org/2000/svg" class="p-icon p-button-icon">
                                      <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="currentColor"></path>
                                </svg>
                              </span>
              
                            </PrimevueButton>
    
                            <div v-if="subSlotProps.data.visibleSelect" class="card" 
                                :style="`z-index: 10; position: absolute; top: 90px; left: ${this.vw*2/5-20}px; min-width: 20rem; transform-origin: center top; margin-top: 2px;`"
                                >
                      
                                  <IconField iconPosition="left" class="pl-1 pt-1">
                                  
                                    <InputIcon class="mr-1">
                                      <i class="pi pi-search "/>
                                    </InputIcon>
                                    <InputText v-model="orderFilters['global'].value" placeholder="Vyhľadať" @input="onOrderFilter(slotProps.data.id,subSlotProps.index)" 
                                  
                                    />
                                  </IconField>
                                <!-- </div> -->
                              <DataTable
                                  
                                  lazy paginator :rows="subSlotProps.data.selectParams.rows"
                                  @page="onOrderPage(slotProps.data.id,subSlotProps.index,$event)"
                                  :first="subSlotProps.data.selectParams.first"
                                  :loading="selectLoading"
                                  :totalRecords="subSlotProps.data.selectParams.totalRecords"
                                  dataKey="id"
                                  :value="subSlotProps.data.orderOptions"
                                  :scrollHeight="`${200}px`"
                                  :virtualScrollerOptions="{ itemSize: 40 }"
                                  stripedRows
                                  row-hover
                                  scrollable
                                  v-model:selection="subSlotProps.data.selectedOrder"
                                  selectionMode="single"
                                  :metaKeySelection="false"
                                  @rowSelect="selectOrder(slotProps.data.id,subSlotProps.index)"
                                  size="small"
                              >
                                  <Column header="ID" field="orderCode" style="width: 5%">
                                  </Column>
                                  <Column header="Meno" field="customer.lastName" style="width: 50%">
                                  </Column>    
                                  <Column header="Obec" field="customer.city" style="width: 45%">
                                  </Column>              
                              </DataTable>              
                            </div>
                          </div> 
                        </template> 
                      </Column>
                      
                      <Column v-if="this.reserved" field="numberOfReservedItems" header="" style="min-width: 2%">
                        <template #body="slotProps">  
                            <InputNumber inputId="numberOfReservedPieces" :useGrouping="false" 
                                v-if="slotProps.data.packageId > 0" 
                                :disabled="!(slotProps.data.selectedOrder) && this.search"
                                v-tooltip.top="{ value: 'Počet kusov k rezervácii' }"
                                v-model="slotProps.data[slotProps.field]" 
                                :inputClass="`${slotProps.data.numberOfReservedItemIsWrong  ? 'bg-red-200 w-full' : 'w-full'}`"
                                :invalid="slotProps.data.numberOfReservedItemIsWrong"
                                placeholder="Rezer. kusy"
                                @input="handleInput(slotProps.data,$event)"
                            /> 
                            <div
                                v-if="slotProps.data.numberOfReservedItemIsWrong"
                                class="text-sm font-italic text-red-400"
                                >
                                Počet rezer. kusov je nesprávny
                            </div>
                        </template>
                       
                      </Column>

                      <Column header="" style="width: 2%">
                        <template #body="subSlotProps">
                          <PrimevueButton v-if="this.reserved && subSlotProps.data.stockItemId > 0" type="button" 
                            v-tooltip.top="{ value: 'Rezervovať' }" icon="pi pi-plus-circle" severity="success"
                            class="pack reserve" @click="confirmReserveStockItem(subSlotProps.data,true)" text size="large"/>
                          
                          <PrimevueButton v-if="!this.reserved && subSlotProps.data.stockItemId > 0" type="button" 
                            v-tooltip.top="{ value: 'Zrušiť z rezervácie' }" icon="pi pi-times-circle" severity="danger"
                            class="pack reserve" @click="confirmReserveStockItem(subSlotProps.data,false)" text size="large"/>

                            
                          <PrimevueButton v-if="this.reserved && subSlotProps.data.packageId > 0" type="button" 
                            v-tooltip.top="{ value: 'Rezervovať' }" icon="pi pi-plus-circle" severity="success"
                            class="pack reserve" @click="confirmReservePack(subSlotProps.data)" text size="large"/>
                              
                          <PrimevueButton v-if="!this.reserved && subSlotProps.data.packageId > 0" type="button" 
                            v-tooltip.top="{ value: 'Zrušiť z rezervácie' }" icon="pi pi-times-circle" severity="danger"
                            class="pack reserve" @click.stop="confirmDeleteReservePack(subSlotProps.data)" text size="large"/>

                        </template>
                      </Column>
                    </DataTable>
                </div>
              </template>
            
        </DataTable>
        
    </div>
    
    
</template>
    
<script lang="ts">
    import Security from './security'
    import {store} from './store'
    import PrimevueButton from "primevue/button";
    import notie from "notie/dist/notie";
    import {FilterMatchMode} from "primevue/api";
    import {emiter} from '../main';
    import IconField from 'primevue/iconfield';
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";    
    import PrimevueSelect from "primevue/dropdown";
    import Utils from './utils';
    import InputIcon from "primevue/inputicon";

    export default {
        name: 'ReservedItems',
        components: {

          PrimevueButton,
          DataTable,
          Column,
          PrimevueSelect,
          InputIcon,
          IconField,
        },
        props: [
           "orderId",
           "reserved",
           "search",
           ],
        data() {
            return {
                store,
                vw: 0,
                numberOfReservedItemIsWrong: false,
                selectedItem: null,
                expandedRows: {},
                reservedItems : [],
                loading: true,
                pagination: {
                    first: 0,
                    rows: 5,
                    totalRecords: 0, 
                    filters: [],
                },
                filterFields: [  {field: 'color',value: ""},
                       {field: 'product',value: ""},
                       {field: 'category',value: ""},
 
                ],
                filters: {
                   
                    color: {value: null, matchMode: FilterMatchMode.EQUALS},
                    product: {value: null, matchMode: FilterMatchMode.EQUALS},
                    category: {value: null, matchMode: FilterMatchMode.EQUALS},
                  
                },
                dataResult: {},
                colors: [],
                categories: [],
                products: [],
                firstLoad: true,
                productId: "",
                selectLoading: false,
                orderFilters : {
                    global: {value: null, matchMode: FilterMatchMode.CONTAINS},
                },
                selectParams: {
                    first: 0,
                    rows: 100,
                    totalRecords: 0,
                    filters:{global: "",
                            table:"order",
                            globalFilterFields: ['OrderCode', 'CustomerId__LastName','CustomerId__City']
                            },

                },
            }
        },

        computed: {
            Utils() {
            return Utils
            },
        },
     
        beforeMount() {
    
          if(Security.requireToken()){
            
            this.setDynamicWidth(); 
            // Aktualizácia šírky pri zmene veľkosti okna
            window.addEventListener("resize", this.setDynamicWidth);

            this.pagination.filters = this.filterFields
            if(this.search){
               this.pagination.rows = 10
            }
            this.loadComponent()
            
            emiter.on('reloadReservation',this.loadComponent)
          }
        },
        

        methods: {

            setDynamicWidth() {
                this.vw = window.innerWidth; // Nastavenie viditeľnej šírky
            },

          loadLazyData(params){
               
            let orderId = this.$props.orderId
            this.loading = true;
            if (orderId != 0) {
                if(this.reserved){
                    orderId = "0"
                }
                this.loading = true;

                let queryParams = "limit="+params.rows+"&offset="+params.first
          
                fetch(store.Api_url + "/reserved-items/" + orderId +"?"+queryParams , Security.requestOptions("POST",params.filters))
                    .then((response) => response.json())
                    .then((responseData) => {
                        if (responseData.error) {
                        //console.log("error:", responseData.message);
                        notie.alert({
                            type: 'error',
                            text: 'Nepodarilo sa načítať zoznam rezervovaných kusov',
                            position: "bottom"
                        })          
                        } else {
                        
                            if (this.firstLoad){
                                this.colors = responseData.data.colors
                                this.products = responseData.data.products
                                this.categories = responseData.data.categories
                                this.firstLoad = false
                            }
                            
                            if (responseData.data.selectedItems) {
                                this.reservedItems = responseData.data.selectedItems;
                                this.reservedItems.forEach((ri) => {
                                    if (ri.items) {
                                        ri.items.forEach((item) => {
                                            item.numberOfReservedItems = null
                                            item.numberOfReservedItemIsWrong = false
                                            item.selectedOrder = null;
                                           
                                            item.visibleSelect = false;
                                            item.selectParams = {...this.selectParams};
                                            item.orderFilters = {...this.orderFilters};
                                            item.orderOptions = [];
                                            
                                         })
                                    }else{
                                        ri.items = []
                                    }
                                })
                            }else{
                                this.reservedItems = []
                            }
                            this.pagination.totalRecords = responseData.totalRecords;
                            this.loading = false;
                                     
        
                        }
                });
            }else{
                this.reservedItems = []
                this.loading = false;
            }
          },
            
            confirmReservePack(data) {

                data.numberOfReservedItemIsWrong = !(data.numberOfReservedItems <= data.numberOfItem && data.numberOfReservedItems > 0)
                
                if (!data.numberOfReservedItemIsWrong){

                    this.$confirm.require({
                        message: 'Naozaj chcete rezervovať kusy s počtom ' + String(data.numberOfReservedItems),
                        header: 'Rezervovanie kusov',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: "Áno",
                        rejectLabel: "Nie",

                        accept: () => {
                            this.reservePack(data)
                            
                        },

                    });                   
                }
                
            },

            confirmDeleteReservePack(data){
                this.$confirm.require({
                        message: 'Naozaj chcete zrušiť rezerváciu kusov ?' ,
                        header: 'Rušenie rezervácie kusov',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: "Áno",
                        rejectLabel: "Nie",

                        accept: () => {
                            this.deleteReservation(data)
                            
                        },

                    })                                   

            },

            deleteReservation(data){
      
                Security.requireToken();
               
                fetch(store.Api_url + "/v1/reserved-item/" + String(data.reservedItemId), Security.requestOptions("DELETE"))
                    .then((response) => response.json())
                    .then((responseData) => {
                        if (responseData.error) {
                       
                        this.$emit('error', responseData.message);
                        notie.alert({
                            type: 'error',
                            text: "Rezerváciu kusov sa nepodarilo zrušiť: " + responseData.message,
                            position: "top"
                            })           
                        } else {

                        notie.alert({
                            type: 'success',
                            text: "Rezervácia kusov bola zrušená",
                            position: "bottom"
                        })
                        //this.package = responseData.data 
                        //this.loadReservations()
                        //this.loadComponent()
                        emiter.emit('reloadReservation')
                        }
                    })
                    .catch((error) => {
                        alert('Chyba pri zrušení rezervácie kusov: ' + error)
                    })
                //}
            },

            onPage(event) {
                this.pagination.first = event.first; 

                this.loadLazyData(this.pagination);
            },
            
            onFilter(event) {
                if (event.filters){

                    if (this.search){
 
                      if (event.filters.product.value){
                        fetch(this.store.Api_url + "/v1/product?query=deleted:0,code:"+event.filters.product.value, Security.requestOptions("GET"))
                            .then((response) => response.json())
                            .then((responseData) => {
                                if (responseData.error) {
                                
                                notie.alert({
                                    type: 'error',
                                    text: "Product sa nepodarilo nájsť"
                                })
                                } else {
                                    let productId = "0"
                                    if (responseData.data){
                                        productId = String(responseData.data[0].id)
                                    }
                                        this.pagination.filters = [ {field: 'color',value: event.filters.color.value ? String(event.filters.color.value["id"]) : ""},
                                                    {field: 'product',value: event.filters.product.value ? productId: ""},
                                                    {field: 'category',value: event.filters.category.value ? String(event.filters.category.value["id"]): ""},

                                                ];
                                        this.pagination.first = 0;  
                                        this.loadLazyData(this.pagination);
                                   
                                }
                            })
                            .catch((error) => {
                                notie.alert({
                                    type: 'error',
                                    text: "Chyba pri vahľadaní produktu: "+error
                                })
                        })
                      }else{
                        this.pagination.filters = [ {field: 'color',value: event.filters.color.value ? String(event.filters.color.value["id"]) : ""},
                                                {field: 'product',value: event.filters.product.value ? String(event.filters.product.value["id"]): ""},
                                                {field: 'category',value: event.filters.category.value ? String(event.filters.category.value["id"]): ""},

                                            ];
                        this.pagination.first = 0;  
                        this.loadLazyData(this.pagination);                        
                      } 
                    }else{
                       
                        this.pagination.filters = [ {field: 'color',value: event.filters.color.value ? String(event.filters.color.value["id"]) : ""},
                                                {field: 'product',value: event.filters.product.value ? String(event.filters.product.value["id"]): ""},
                                                {field: 'category',value: event.filters.category.value ? String(event.filters.category.value["id"]): ""},

                                            ];
                        this.pagination.first = 0;  
                        this.loadLazyData(this.pagination);

                    }
                    
       
                }else{
                    this.pagination.filters= this.filterFields
                    this.pagination.first = 0;  
                    this.loadLazyData(this.pagination);
                }
                   

            },
            
            loadComponent(){

                this.pagination.first = 0
                this.pagination.totalRecords = 0

                this.loadLazyData(this.pagination)
 
            },

            confirmReserveStockItem(item,reserved:boolean){
                //console.log("Confirm:", reserved);
                if (reserved) {
                    this.$confirm.require({
                        message: 'Naozaj chcete rezervovať kus ? ',
                        header: 'Rezervovanie kusa',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: "Áno",
                        rejectLabel: "Nie",

                        accept: () => {
                            this.reserveStockItem(item,reserved)
                            
                        },

                    });                   
                }else{
                    this.$confirm.require({
                        message: 'Naozaj chcete zrušiť rezerváciu kusa ?' ,
                        header: 'Rušenie rezervácie kusa',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: "Áno",
                        rejectLabel: "Nie",

                        accept: () => {
                            this.reserveStockItem(item,reserved)
                            
                        },

                    })                     
                }
            },

            reserveStockItem(item,reserved:boolean) {
                
                let text = "Rezervácia kusa bola úspešne vykonaná"
                let textChyba = "Chyba pri rezervovaní kusa"
                let formData = {
                        id: item.stockItemId,
                        reserved: true,
                        order: {id: parseInt(this.orderId)},
                    }
                
                if (this.search){
                    formData.order = item.selectedOrder
                }   

                if (!reserved) {
                    formData = {
                        id: item.stockItemId,
                        reserved: false,
                        order: {id: 0},
                    }
                    text = "Zrušenie rezervácie kusa bolo úspešne vykonané"
                    textChyba = "Chyba pri zrušení rezervácie kusa"
                }

                const method = "PUT"
                const url = "/reserve-stock-item"
                    
 
                fetch(store.Api_url + url, Security.requestOptions(method, formData))
                    .then((response) => response.json())
                    .then((responseData) => {
                        if (responseData.error) {
                       
                        notie.alert({
                            type: 'error',
                            text: responseData.data.message
                        })
                        } else {
                            notie.alert({
                                type: 'success',
                                text: text
                            })
                            
                            //this.loadComponent()
                            this.addStockMovement(item,reserved)
                            emiter.emit('reloadReservation')
                        }
                    })
                    .catch((error) => {
                        this.$emit('error', textChyba+ " " + error);
                        notie.alert({
                        type: 'error',
                        text: textChyba +" " + error
                        })
                    })
            },

            reservePack(item){

                if (item.numberOfReservedItems <= item.numberOfItem && item.numberOfReservedItems > 0)
                {
                    let formData = {
                    id: 0,
                    numberOfItems: item.numberOfReservedItems,
                    package: {id: item.packageId},
                    order: {id: this.store.order.id},
                    multiPack: {id: item.multiPackId},
                    color: item.color,
                    product: item.product,
                    deleted: false,
                    }

                    if (this.search){
                        formData.order = item.selectedOrder
                    }

                    let method = "POST"
                    let url = "/v1/reserved-item"
            
                    //this.typeOfAction = "CHA"

                    fetch(store.Api_url + url, Security.requestOptions(method, formData))
                        .then((response) => response.json())
                        .then((responseData) => {
                        if (responseData.error) {
                            //console.log("error:", responseData.data.message);

                            notie.alert({
                            type: 'error',
                            text: responseData.data.message
                            })
                        } else {

                            //this.loadComponent()
                            emiter.emit('reloadReservation')
                        }
                        })
                        .catch((error) => {
                        //this.$emit('error', "Chyba pri uložení balíka" + error);
                        notie.alert({
                            type: 'error',
                            text: "Chyba pri rezervácii kusov" + error
                        })
                    })
                }
            },

            addStockMovement(item,reserved:boolean){
                let dataMovement = {stockItem:{id:item.stockItemId},
                                        action:"",
                                        user:this.store.user,
                                        color:"",
                                        order:{}
                                    }
                let orderCode =  String(this.store.order.orderCode)                   
                if (this.search){
                    dataMovement.order = item.selectedOrder
                    orderCode = item.selectedOrder.orderCode
                }else{
                    dataMovement.order = {id:this.store.order.id}
                    
                }
                if (reserved){
                    dataMovement.action = Utils.getReservedOrderTextAction("Kus",orderCode)
                    
                    Utils.addStockMovement(dataMovement,"stock_item_id","CHA",item.stockItemId)
                }else{
                    dataMovement.action = Utils.getCanceledReservationOrderTextAction("kusa",orderCode)
                    
                    Utils.addStockMovement(dataMovement,"stock_item_id","CHA",item.stockItemId)
                }

            },

            handleInput(item,number) {

                this.reservedItems.forEach((ri) => {
                                    if (ri.items) {
                                        ri.items.forEach((it) => {
                                           
                                            if (it.id == item.id){
                                                item.numberOfReservedItems = number.value
                                                item.numberOfReservedItemIsWrong = !(!number.value || (number.value <= item.numberOfItem && number.value > 0))
                                            }
                                         })
                                    }
                })

            },

        getMainRowIndex(id:number) {
            return this.reservedItems.findIndex(row => row.id === id);
        },


        selectOrder(id:number,index:number){
            const mainIndex = this.getMainRowIndex(id)
            this.reservedItems[mainIndex].items[index].visibleSelect = false

        },

        onOrderPage(id:number,index:number,event) {
            const mainIndex = this.getMainRowIndex(id)
            this.reservedItems[mainIndex].items[index].selectParams.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

            this.loadLazyDataOrders(mainIndex,index,this.reservedItems[mainIndex].items[index].selectParams)
        },

        onOrderFilter(id:number,index:number) {
            const mainIndex = this.getMainRowIndex(id)
            this.reservedItems[mainIndex].items[index].selectParams.filters.global = this.orderFilters.global.value
            this.reservedItems[mainIndex].items[index].selectParams.first = 0
            
            if(this.reservedItems[mainIndex].items[index].selectParams.filters.global.length > 2){
                this.loadLazyDataOrders(mainIndex,index,this.reservedItems[mainIndex].items[index].selectParams)
            }
        },

        initOrders(id:number,index:number){
            const mainIndex = this.getMainRowIndex(id)
            this.reservedItems[mainIndex].items[index].visibleSelect = !this.reservedItems[mainIndex].items[index].visibleSelect
            this.reservedItems[mainIndex].items[index].selectParams.first = 0
            this.reservedItems[mainIndex].items[index].selectParams.rows = 100
            this.reservedItems[mainIndex].items[index].selectParams.filters.global = ""
            this.reservedItems[mainIndex].items[index].orderFilters = {
                global: {value: null, matchMode: FilterMatchMode.CONTAINS},

            }
            this.loadLazyDataOrders(mainIndex,index,this.reservedItems[mainIndex].items[index].selectParams)
            //this.isMovement = false
            
            //this.typeOfAction = ""
            //this.typeOfMultiPackAction = ""
        },

        loadLazyDataOrders(mainIndex:number,index:number,params) {
            
            this.selectLoading = true;

            let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

            fetch(`${store.Api_url}${this.store.basicUrlFilterOrders}${queryParams}`, Security.requestOptions("POST",params.filters))
            .then((response) => response.json())
            .then((responseData) => {
            if (!responseData.error) {
                if (responseData.data){
                    this.reservedItems[mainIndex].items[index].orderOptions = responseData.data
                }else{this.reservedItems[mainIndex].items[index].orderOptions = []}
                this.reservedItems[mainIndex].items[index].selectParams.totalRecords = responseData.totalRecords
                this.selectLoading = false;
            }
            })
            .catch((error) => {
                this.reservedItems[mainIndex].items[index].orderOptions = []
                this.selectLoading = false;
            })
        },
    },

    beforeUnmount(){
        emiter.off('reloadReservation',this.loadComponent)
        window.removeEventListener("resize", this.setDynamicWidth);
    },  
}    
</script>